/** @module Apparel/ArchiveSeasonController */
define([
    "dojo/_base/declare",
    "csi/action/Controller"
], function(declare,ActionController) {

    return declare(ActionController, {

        /**
         * Add Season name to the archive dialog title.
         * @param {Object} params
         */
        confirmAction: function(params) {
            params = params || {};
            params.title =  "Archive " + this.getNode().$Name + "?";
            this.inherited(arguments);
        },
 
    });
});